import { useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchOnixCodetables } from "../api/onixService";
import { DEFAULT_PAGE_SIZE } from "../utils/constants";
export var useOnixCodetablesData = function (applied, pageSize) {
    var _a, _b;
    if (pageSize === void 0) { pageSize = DEFAULT_PAGE_SIZE; }
    var ky = useOkapiKy();
    var _c = useState(0), pageOffset = _c[0], setPageOffset = _c[1];
    var _d = useQuery(["onix-codetables", applied, pageOffset, pageSize], function () {
        return fetchOnixCodetables(ky, {
            number: applied.number,
            name: applied.name,
            offset: pageOffset,
            limit: pageSize,
        });
    }, { keepPreviousData: true }), data = _d.data, isLoading = _d.isLoading, isError = _d.isError, isFetched = _d.isFetched;
    var items = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
    var totalRecords = (_b = data === null || data === void 0 ? void 0 : data.totalRecords) !== null && _b !== void 0 ? _b : items.length;
    var fetchMoreData = function (offset) {
        setPageOffset(offset);
    };
    var resetPageOffset = function () { return setPageOffset(0); };
    return {
        items: items,
        totalRecords: totalRecords,
        isLoading: isLoading,
        isError: isError,
        isFetched: isFetched,
        fetchMoreData: fetchMoreData,
        resetPageOffset: resetPageOffset,
        pageOffset: pageOffset,
        pageSize: pageSize,
    };
};
